// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"464":"67095341","931":"db5720e7"}[chunkId] + ".chunk.css";
};